"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftLoading_styles_1 = require("./LftLoading.styles");
var loader_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/loader"));
var LftLoading = function (_a) {
    var bgColor = _a.bgColor, id = _a.id;
    return (0, jsx_runtime_1.jsx)(LftLoading_styles_1.LoadingStyled, { bgColor: bgColor, dangerouslySetInnerHTML: { __html: loader_1.default }, "data-lift": "lft-loading", id: id }, void 0);
};
exports.default = LftLoading;
